var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5141 4.48444C23.7923 3.40799 21.9096 3.03129 19.8668 3.35106L19.5634 19.0447L25.5141 4.48444Z",
    fill: "#313130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3088 34.7103C17.2968 35.0374 15.4146 34.6585 13.6615 33.5769L19.6122 19.0166L19.3088 34.7103Z",
    fill: "#313130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1201 24.9573C35.2127 23.2019 35.6065 21.2897 35.3048 19.2213L19.602 19.054L34.1201 24.9573Z",
    fill: "#313130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0596 13.0984C3.96695 14.8538 3.57314 16.766 3.87489 18.8343L19.5777 19.0017L5.0596 13.0984Z",
    fill: "#313130"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlack);
export default __webpack_public_path__ + "static/media/star-black.c18141c99576c08d5fdf841d883bc2fa.svg";
export { ForwardRef as ReactComponent };